export default __webpack_public_path__ + "static/media/bitcoin-birds-sm.61cd4567.png";